export default "__VITE_ASSET__CvNo1civ__"